import {IconButton, Tooltip, useTranslationContext} from 'platform/components';

import {useState} from 'react';

import {suffixTestId, type TestIdProps} from 'shared/web';

import {useIsGridMaximized} from '../../store/selectors/useIsGridMaximized';
import {useEagGridStore} from '../../store/useEagGridStore';

export function MaximizeGridButton(props: TestIdProps) {
  const t = useTranslationContext();
  const store = useEagGridStore();
  const isMaximized = useIsGridMaximized();
  const [isTooltipSuppressed, setIsTooltipSuppressed] = useState(false);
  const label = t(isMaximized ? 'general.actions.exitFullScreen' : 'general.actions.maximizeList');

  return (
    <span onPointerEnter={() => setIsTooltipSuppressed(false)}>
      <Tooltip label={label} isDisabled={isTooltipSuppressed}>
        <IconButton
          aria-label={label}
          aria-expanded={isMaximized}
          icon={isMaximized ? 'navigation/fullscreen_exit' : 'navigation/fullscreen'}
          onClick={(event) => {
            // Safari does not focus clicked buttons. Preserve a real return-focus target.
            event.currentTarget.focus({preventScroll: true});
            setIsTooltipSuppressed(true);
            store.setIsMaximized(!isMaximized);
          }}
          data-testid={suffixTestId('maximizeGrid', props)}
        />
      </Tooltip>
    </span>
  );
}
